import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getPurchaseDashboardSupplier,
  getLatestPurchaseDashboardDetails,
  getSupplierPurchaseData,
} from "../helper/dashboardHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { Button } from "@material-ui/core";
import ApexChart from "react-apexcharts";

const initialData = {
  labels: [],
  datasets: [
    {
      label: "Supplier Purchases",
      data: [],
      backgroundColor: [],
      borderColor: [],
      borderWidth: 1,
    },
  ],
};

function CategoryPurchaseDashboard() {
  const [storeId, setStoreId] = useState([]);
  const [year, setYear] = useState(new Date());
  const [graphData, setGraphData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState();
  const [graphType, setGraphType] = useState("donut");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  useEffect(() => {
    if (graphType === "donut") {
      const store = JSON.parse(getSessionData({ key: "store" }));
      setStoreId(store.storeid);
      getLatestPurchaseDashboardDetails(store.storeid)
        .then((response) => {
          if (response && response.length > 0) {
            setFromDate(new Date(response[0].year, response[0].month - 1));
          }
        })
        .catch((err) => {});
    }
  }, []);

  useEffect(() => {
    return () => {};
  }, []);

  const color = [
    "rgba(153, 102, 255, 0.9)",
    "rgba(255, 159, 64, 0.9)",
    "rgba(255, 99, 132, 0.9)",
    "rgba(54, 162, 235, 0.9)",
    "rgba(255, 206, 86, 0.9)",
    "rgba(75, 192, 192, 0.9)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
  ];

  const ApexChartOptions = {
    colors: color,
    series: graphData?.datasets[0]?.data,
    labels: graphData?.labels,
    chart: {
      type: "donut",
      events: {
        dataPointSelection: function(event, chartContext, config) {
          if (graphType !== "pie") {
            handleSupplierSelect(config);
          }
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: false,
              fontSize: "14px",
              fontWeight: "600",
            },
          },
        },
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "14px",
      formatter: function(val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
    },
  };

  const loadDashboard = (store_id, startDate, endDate, supplier = null) => {
    setLoading(true);

    if (
      store_id.length &&
      store_id !== "" &&
      startDate !== "" &&
      endDate !== ""
    ) {
      getPurchaseDashboardSupplier(store_id, startDate, endDate)
        .then((response) => {
          if (response && response.length > 0) {
            var data = {
              labels: [],
              datasets: [
                {
                  label: "# of Votes",
                  data: [],
                  backgroundColor: [],
                  borderColor: [],
                  borderWidth: 1,
                },
              ],
            };
            response.map((item, index) => {
              data.labels.push(item.suppliername);
              data.datasets[0].data.push(item.invamt);
              data.datasets[0].backgroundColor.push(color[index]);
              data.datasets[0].borderColor.push(color[index]);
              return "";
            });
            setGraphData(data);
          } else {
            setGraphData(initialData);
          }
          setLoading(false);
        })
        .catch((err) => {});
    } else {
      setGraphData({
        ...graphData,
        labels: [],
      });
      setLoading(false);
    }
  };

  const loadSingleSupplierDashboard = (
    storeId,
    startDate,
    endDate,
    supplier
  ) => {
    getSupplierPurchaseData(storeId, startDate, endDate, supplier)
      .then((response) => {
        if (response && response.length > 0) {
          var data = {
            labels: [],
            datasets: [
              {
                label: "# of Votes",
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
              },
            ],
          };
          response.map((item, index) => {
            data.labels.push(item.brandgeneric);
            data.datasets[0].data.push(item.invamt);
            data.datasets[0].backgroundColor.push(color[index]);
            data.datasets[0].borderColor.push(color[index]);
            return "";
          });
        }
        setGraphData(data);
        setLoading(false);
      })
      .catch((err) => {
        setGraphData({
          ...graphData,
          labels: [],
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    const handleFilterChange = () => {
      if (!storeId || !fromDate || !toDate) return;
      if (graphType === "donut") {
        loadDashboard(storeId, fromDate, toDate);
      } else {
        if (!selectedSupplier) return;
        loadSingleSupplierDashboard(
          storeId,
          fromDate,
          toDate,
          selectedSupplier
        );
      }
    };
    handleFilterChange();
  }, [fromDate, toDate, storeId, selectedSupplier, graphType]);

  const handleSupplierSelect = (config) => {
    setLoading(true);
    let supplierName = config.w.config.labels[config.dataPointIndex];
    setGraphType("pie");
    setSelectedSupplier(supplierName);
  };

  const handleChartChange = (event) => {
    setGraphType("donut");
  };

  return (
    <div style={{ height: "565px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          p: 1,
          m: 1,
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <strong>Category Purchase</strong>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: "2rem",
        }}
      >
        <Grid
          container
          direction="row"
          item
          xs={12}
          style={{
            marginTop: "0.25rem",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid item xs={5}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoFocus
                margin="normal"
                autoOk={true}
                id="year"
                label="From Date"
                format="yyyy-MM-dd"
                value={fromDate}
                onChange={setFromDate}
                okLabel={""}
                cancelLabel={""}
                views={["year", "month", "date"]}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={5}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                margin="normal"
                autoOk={true}
                id="year"
                label="To Date"
                format="yyyy-MM-dd"
                value={toDate}
                onChange={setToDate}
                okLabel={""}
                cancelLabel={""}
                views={["year", "month", "date"]}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>

        <div
          style={{
            width: "30%",
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {graphType === "pie" && (
            <Button
              variant="outlined"
              onClick={(e) => handleChartChange(e)}
              startIcon={<ChevronLeftIcon />}
            >
              Back
            </Button>
          )}
        </div>
      </Box>
      {!loading ? (
        graphData &&
        graphData.labels &&
        graphData.labels.length > 0 &&
        ApexChartOptions.series ? (
          <Box style={{ display: "flex", justifyContent: "center" }}>
            <ApexChart
              options={ApexChartOptions}
              series={ApexChartOptions?.series}
              type="donut"
              height={430}
              width={650}
            />
          </Box>
        ) : (
          <Box style={{ display: "flex", justifyContent: "center" }}>
            <strong>No records to display</strong>
          </Box>
        )
      ) : (
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(CategoryPurchaseDashboard);
